import { arrayOf, number, func, array, object, string } from "prop-types";
import React from "react";

const TimesheetColumnTotalTimeFrameRow = ({
  totals,
  columnErrors,
  bookedDays,
  nonAttendanceDays,
  nonAttendanceCodes,
  returnDays,
}) => {
  return (
    <tr>
      <td />
      {totals.map((total, i) => (
        <td key={i}>
          {returnDays(
            columnErrors[i],
            bookedDays[i],
            nonAttendanceDays[i],
            total,
            nonAttendanceCodes
          )}
        </td>
      ))}
    </tr>
  );
};

TimesheetColumnTotalTimeFrameRow.propTypes = {
  totals: arrayOf(number),
  columnErrors: array,
  bookedDays: array,
  nonAttendanceDays: array,
  nonAttendanceCodes: object,
  returnDays: func,
};

export default TimesheetColumnTotalTimeFrameRow;
